var ac = function(link){
    var iframe = '<iframe scrolling="no" frameborder="0" src="'+link+'" style="z-index:99999;cursor:pointer; overflow: hidden !important;" allowtransparency="true"></iframe>'
    var msg = '<div title="Close" class="'+popup.modalclass+'" style="z-index:100000;cursor:pointer;">'+iframe+'</div>';
    $('.modal').append(msg);
}
var removeWidget = function(type){
    var sufix = '_widget-in';
    $('#'+type+sufix).remove(); 
}
var cleanUnder = function(st){
    return st.replace(/^_+|_+$/g,"");
}  
$(document).ready(function() {   
    var cookie = Object.create(Cookie).constructor(popup);    
    cookie.check();
    var like = Object.create(Like).constructor(); 
    modalRun = function(){
        if(popup.place_type == 1){
            $('.modal').modal({
                closeClass: 'icon-remove',
                closeText: '<i class="icon-cross"></i>',
                escapeClose: false,
                clickClose: false,
                showClose: true
            });
            /*check = setInterval(function () {
            var hight = 1*$(".fb-like > span").height();
            if (hight == 14) {
            Tinit.at_remove('facebook',id);
            clearInterval(check);
            }
            }, 3000);*/
        }
        if(popup.place_type == 2){
            $('.modal').show();   
        }
    }
    if (cookie.getStatus() === true && popup.statein == 1 && popup.max != 0) {
        $.ajax({
            url: "/js/social-login.js",
            dataType: "script",
            cache: true
        });
        popup.statein = 2;  // popup runned;
    }else{
        popup.statein = 3;
    } 
    var Tinit = {
        listener: function (event) {
            if (!event || !event.data || !event.data.action) return;
            var action = event.data.action;
            console.log(event);
            Tinit['at_'+action](event.data.url, event.data.id);
        },
        at_show: function(url, id) {
            $.modal.open();    
        },
        at_hide: function(url, id) {
            $.modal.close();
        },
        at_remove: function(url, id){
            console.log(url, id);
            like.TurnOff('facebook',id);
            this.at_hide();
        },           
        at_like: function(url, id){
            console.log(url, id);
            like.pageLike('facebook',id, 2);
            this.at_hide();
        },
        at_unlike: function(url, id){
            console.log(url, id);
            like.pageUnLike('facebook',id, 2); 
        } 
    };
    (window.attachEvent || window.addEventListener)('message',  Tinit.listener); 
    $(document).bind('socialevent', function(e, socialStatus) {
        fbEnsureInit(function(){
            FB.Event.subscribe('edge.create', function(response) {
                console.log(response,'event+');
                like.pageLike('facebook',response, 1);
            });
            FB.Event.subscribe('edge.remove', function(response) {
                console.log(response,'event+');
                like.pageUnLike('facebook',response, 1);
            });
        });
        var prop_state = {};
        $('.modal > div').each(function(){
            if(typeof($(this).attr('id')) !== 'undefined'){
                id = $(this).attr('id').match(/^(.+?)_/iu)[0];
                if(!prop_state.hasOwnProperty( id )){
                    prop_state[id] = $(this).data('status');
                }
            }
        });
        var get_widget = Object.create(GetWidget).constructor(socialStatus,popup.priority,prop_state,popup.def); 
        var choised = get_widget.findWidget();
        for( var ss in prop_state ) {
            var clean = cleanUnder(ss);
            if(socialStatus[choised] == 1){
                if(choised == ss && popup.url.hasOwnProperty( clean ) && popup.cj == 1) {
                    ac(popup.url[clean]['uri']);
                }
            }
            if( prop_state.hasOwnProperty( ss ) && ss != choised) {
                removeWidget(ss);
            }
        }
        //Setting CSS property of social__widget  global_config.img
        if (typeof global_config != "undefined") {
            if (global_config.hasOwnProperty('website_min')) {
                $('.social__widget').each(function(){
                    $(this).css('background-image', "url("+global_config.website_min+")");
                    $(this).css('background-size', "cover");
                })
            }
        }
        cookie.popup();
    });           
});       